import { type FC } from 'react';
import { Trans } from 'react-i18next';

import { TextSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import contractPng from '/img/icons/contract.png';
import contractWebp from '/img/icons/contract.webp';
import leaguePng from '/img/icons/leagues-point.png';
import leagueWebp from '/img/icons/leagues-point.webp';
import pointsPng from '/img/icons/star-large.png';
import pointsWebp from '/img/icons/star-large.webp';

const ArenaBenefits: FC = () => {
  const benefitsData = [
    {
      key: 'contract',
      text: 'Complete </1> contracts',
      image: {
        img: contractPng,
        webp: contractWebp,
      },
    },
    {
      key: 'points',
      text: 'Earn </1> Star Points',
      image: {
        img: pointsPng,
        webp: pointsWebp,
      },
    },
    {
      key: 'opponents',
      text: 'Defeat </1> opponents',
      image: {
        img: leaguePng,
        webp: leagueWebp,
      },
    },
  ];

  return (
    <div className="w-full flex px-[2.625rem] gap-4 items-center mb-8">
      {benefitsData.map(({ key, text, image }) => (
        <div key={key} className="flex flex-col flex-1 gap-1 items-center">
          <Picture className="w-12 h-12 gap-1" {...image} alt={key} />
          <TextSmall className="!text-white/80 !leading-1.2 text-center">
            <Trans i18nKey={text} components={{ 1: <br /> }} />
          </TextSmall>
        </div>
      ))}
    </div>
  );
};

export { ArenaBenefits };
